class MapFilterPageController {

  constructor(FiltersService, AlertService, LoaderService) {
    this.FiltersService = FiltersService;
    this.AlertService = AlertService;
    this.LoaderService = LoaderService;
  }

  $onInit() {
    var self = this;
    self.adverts = [];
    self.LoaderService.start();
    self.FiltersService.getAll()
        .then( (filters)=> self.filters = filters )
        .catch( (error)=> self.AlertService.error("There was a problem getting the Filters") )
        .finally( () => self.LoaderService.stop() );
  }

  orderChanged(index) {
    console.log('index', index);
    var self = this;
    self.filters.splice(index, 1);

    self.LoaderService.start();
    self.FiltersService.reorder(self.filters)
        .then( () => self.AlertService.success("Filter order changed successfully") )
        .catch( (error)=> self.AlertService.error("There was a problem getting the Filters") )
        .finally( () => self.LoaderService.stop() );
  }

}

MapFilterPageController.$inject =  ['FiltersService', 'AlertService', 'LoaderService'];
export default MapFilterPageController;
